import { useEffect, useState, } from "react";
import Loader from "./sections/loader";


import Home from "./pages/home";
import { useDispatch, useSelector } from "react-redux";
import { fetchHomepageData } from "./redux/slice/homepage";

// const MainComponent = lazy(() => import('./pages/home'));
function App() {
    const [isLoading, setIsLoading] = useState(true);
    const location  = window.location.pathname

    // useEffect(() => {
    //   const timer = setTimeout(() => {
    //     setIsLoading(false);
    //   }, 5000); // Set the duration in milliseconds (e.g., 3000 for 3 seconds)

    //   return () => clearTimeout(timer); // Cleanup the timer on component unmount
    // }, [isLoading]);

    useEffect(() => {
        // Simulate an API call
        setTimeout(() => {
            setIsLoading(false);
        }, 3300);
    }, []);

    const dispatch = useDispatch()


    useEffect(() => {
        dispatch(fetchHomepageData())
    },[])


    return (
        <>

            {/* <ScrollToTop/> */}
            {/* <Suspense fallback={<Loader />}>

                <MainComponent />
            </Suspense> */}
            {(isLoading && location === '/') ? <Loader /> : <Home />}
            {/* <Home /> */}
            {/* <button onClick={() => dispatch(fetchHomepageData())} className="text-3xl bg-red-400 text-white p-2">Get</button> */}

          
        </>
    )
}

export default App;
